/**
 * 分拣机类型枚举（字符串名）
 * 对应后端 SorterType 的 name
 */
export enum SorterType {
    DWS = 'DWS',
    CROSS_BELT = 'CROSS_BELT',
    SMALL_PARCEL_SCANNER = 'SMALL_PARCEL_SCANNER',
    RAPID_SCAN = 'RAPID_SCAN',
    LINEAR_SORTER = 'LINEAR_SORTER'
}

/**
 * 分拣机类型编码（数字）
 * 对应后端 SorterType.code，用于 GraphQL 接口入参 / 出参（int）和 form value
 */
export enum SorterTypeCode {
    DWS = 1,
    CROSS_BELT = 2,
    SMALL_PARCEL_SCANNER = 3,
    RAPID_SCAN = 4,
    LINEAR_SORTER = 5
}

/**
 * 分拣机类型翻译键映射
 */
export const SorterTypeTranslationKey: Record<SorterType, string> = {
    [SorterType.DWS]: 'enum.sorterType.dws',
    [SorterType.CROSS_BELT]: 'enum.sorterType.crossBelt',
    [SorterType.SMALL_PARCEL_SCANNER]: 'enum.sorterType.smallParcelScanner',
    [SorterType.RAPID_SCAN]: 'enum.sorterType.rapidScan',
    [SorterType.LINEAR_SORTER]: 'enum.sorterType.linearSorter'
};

